export default "__VITE_ASSET__BRKCdOG___"